import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { addError } from 'actions';
import { appInsights } from 'lib/appInsights';
import api from 'lib/api';
import getEnvironment from 'lib/env';
import { getToken, loginRequest } from 'lib/msal';
import Select from './select';
import { GraphFileBrowser } from '@microsoft/file-browser';
import Modal from 'containers/Modals/Modal';
import OneDrivePicker from 'containers/OneDrivePicker/';
import { Expandable, Spinner } from 'UI';
import { MS_OneDrive } from 'UI/Icons';
import { Button, Icon, translate } from '@haldor/ui';
var modalStyles = {
  content: {
    width: '60%',
    margin: '0 auto',
    marginBottom: '40px',
    padding: '0',
    borderRadius: '7px'
  }
};

var Upload = /*#__PURE__*/function (_Component) {
  _inherits(Upload, _Component);

  var _super = _createSuper(Upload);

  function Upload(props) {
    var _this;

    _classCallCheck(this, Upload);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      api.get('https://graph.microsoft.com/beta/me/drive/root/children').then(function (response) {
        if (response.status == 200) {
          // User has access via Files.ReadWrite.All
          _this.setState({
            newPicker: true
          });
        } else {
          // User is missing scope for Files.ReadWrite.All
          appInsights.trackTrace({
            message: "FilePicker UI - Customer has not consented new File Picker. Decoded Token is null, can't provide customer information"
          }, {
            tenantId: _this.props.tenant.id
          });

          _this.setState({
            newPicker: false
          });
        }
      }, function (err) {
        _this.setState({
          newPicker: false
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getFile", function (file) {
      return new Promise(function (resolve) {
        api.get('https://graph.microsoft.com/beta/me/drives/' + file.driveItem_203[1] + '/items/' + file.driveItem_203[2]).then(function (response) {
          if (response.data != null && response.data["package"] != null) {
            if (response.data["package"].type != null && response.data["package"].type == "oneNote") {
              resolve();
            }
          }

          resolve({
            key: response.data.name,
            value: response.data['@microsoft.graph.downloadUrl'],
            parentReference: response.data['parentReference'],
            id: response.data['id'],
            mimeType: response.data['file'].mimeType,
            fileType: 0
          });
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getAuthenticationToken", function () {
      return new Promise(function (resolve) {
        var request = loginRequest;
        request.scopes = ["Files.ReadWrite.All"].concat(_toConsumableArray(request.scopes));
        getToken(request).then(function (response) {
          resolve(response.accessToken);
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "launchOneDrivePicker", function () {
      var that = _assertThisInitialized(_this);

      var odOptions = {
        clientId: getEnvironment().clientId,
        action: 'query',
        multiSelect: true,
        openInNewWindow: true,
        advanced: {
          //redirectUri: `${window.location.origin}/fileInputRedirect.html`,
          queryParameters: 'select=id,name,size,file,folder,photo,webUrl,webDavUrl,location'
        },
        success: function success(files) {
          var pickedItems = [];
          files.value.forEach(function (file) {
            var oneDriveFile = {
              key: file.name,
              value: file.webDavUrl,
              fileType: 0
            };
            pickedItems.push(oneDriveFile);
          });
          that.setState({
            forceUpdate: true,
            pickedItems: pickedItems
          }, function () {
            that.props.onUpdate(pickedItems);
          });
        },
        cancel: function cancel() {},
        error: function error(e) {
          console.log(e);
        }
      };
      OneDrive.open(odOptions);
    });

    _defineProperty(_assertThisInitialized(_this), "selectFileType", function (event, file) {
      file.fileType = event.target.value;

      _this.setState({}, function () {
        _this.props.onUpdate(_this.state.pickedItems);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onRemove", function (file) {
      var pickedItems = _toConsumableArray(_this.state.pickedItems).filter(function (doc) {
        return doc.value !== file.value;
      });

      _this.setState({
        pickedItems: pickedItems
      }, function () {
        _this.props.onUpdate(pickedItems);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "filesList", function () {
      var pickedItems = _this.state.pickedItems;
      var foundDocument = pickedItems.find(function (file) {
        if (file.fileType != null) {
          return file.fileType == 0;
        }

        return false;
      });
      var documentsPassing = true;

      if (foundDocument != null) {
        documentsPassing = false;
      }

      if (!pickedItems) {
        return /*#__PURE__*/React.createElement("div", null);
      }

      return /*#__PURE__*/React.createElement("div", null, !documentsPassing && _this.props.form == 'assignment' ? /*#__PURE__*/React.createElement("div", {
        style: {
          paddingTop: '1rem'
        }
      }, _this.props.translate('need-to-select-file-types'), "!") : null, pickedItems.map(function (file, i) {
        if (file.key != "" && file.key != null) {
          return /*#__PURE__*/React.createElement("div", {
            key: file.value,
            className: "attached-file"
          }, _this.props.lockedStatus && file.fileType === '2' ? /*#__PURE__*/React.createElement("div", {
            style: {
              transform: 'scale(1.1)'
            }
          }, /*#__PURE__*/React.createElement(Icon, {
            name: "Lock"
          })) : /*#__PURE__*/React.createElement(Icon, {
            name: "File"
          }), /*#__PURE__*/React.createElement("span", {
            className: "file-name"
          }, file.key), _this.props.form == 'assignment' ? /*#__PURE__*/React.createElement(Select, {
            name: "filetype",
            options: _this.state.fileTypes,
            selectedValue: file.fileType,
            onChange: function onChange(event) {
              return _this.selectFileType(event, file);
            },
            placeholder: _this.props.translate('choose-filetype')
          }) : null, /*#__PURE__*/React.createElement(Button, {
            type: "secondary",
            onClick: function onClick() {
              _this.onRemove(file);
            }
          }, _this.props.translate('Delete')));
        }
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "onBrowserSuccess", function (keys) {
      var pickedItems = _this.state.pickedItems;
      var addError = _this.props.addError;

      _this.setState({
        loadingPicker: true
      });

      Promise.all(keys.map(function (file) {
        return new Promise(function (resolve, reject) {
          _this.getFile(file).then(function (data) {
            resolve(data);
          });
        });
      })).then(function (selected) {
        selected.map(function (sel) {
          if (sel != null) {
            pickedItems.push(sel);
          } else {
            addError("OneNote files is not allowed", "error");
          }
        }); // Filter duplicate items with the same key property

        pickedItems = pickedItems.filter(function (obj, pos, arr) {
          return arr.map(function (mapObj) {
            return mapObj['key'];
          }).indexOf(obj['key']) === pos;
        });

        _this.setState({
          pickedItems: pickedItems,
          modalIsOpen: false,
          loadingPicker: false
        }, function () {
          _this.props.onUpdate(_this.state.pickedItems);
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onGroupSelect", function (group) {
      _this.setState({
        graphPickerUrl: 'https://graph.microsoft.com/beta/groups/' + group.graphId,
        newPicker: null,
        activeSelection: group.graphId
      }, function () {
        _this.setState({
          newPicker: true
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onOneDrivePickerChange", function (files) {
      var parsedFiles = [];
      files.map(function (file) {
        if (file.url != null) {
          var add = {
            key: file.name,
            value: file.url,
            markedForDeletion: false,
            fileType: 0
          };
          parsedFiles.push(add);
        }
      });

      _this.setState({
        pickedItems: parsedFiles
      }, function () {
        _this.props.onUpdate(_this.state.pickedItems);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onGoOneDrive", function () {
      _this.setState({
        graphPickerUrl: 'https://graph.microsoft.com/beta/me/',
        newPicker: null,
        activeSelection: 'me'
      }, function () {
        _this.setState({
          newPicker: true
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "openModal", function () {
      _this.setState({
        modalIsOpen: true
      }, function () {
        _this.props.onUpdate([]);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeModal", function () {
      _this.setState({
        modalIsOpen: false
      });
    });

    _this.state = {
      modalIsOpen: false,
      fileTypes: [{
        value: 1,
        text: props.translate('instructions')
      }, {
        value: 2,
        text: props.translate('template-document')
      }],
      forceUpdate: false,
      newPicker: null,
      graphPickerUrl: 'https://graph.microsoft.com/beta/me',
      activeSelection: 'me',
      pickedItems: [],
      loadingPicker: false
    };
    return _this;
  }

  _createClass(Upload, [{
    key: "isIframe",
    value: function isIframe() {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var meClassname = 'section-item';

      if (this.state.activeSelection == 'me') {
        meClassname = meClassname + ' active';
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "upload-wrapper",
        key: "upload-wrapper-picker"
      }, this.state.newPicker == true ? /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.modalIsOpen,
        type: "file-picker",
        onClose: this.closeModal,
        style: modalStyles
      }, this.state.loadingPicker ? /*#__PURE__*/React.createElement("div", {
        className: "is_sending"
      }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
        className: "loading-spinner"
      }))) : null, /*#__PURE__*/React.createElement("h3", {
        style: {
          padding: '0.5rem 0'
        }
      }, this.props.translate('places')), /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: '1.5rem'
        }
      }, /*#__PURE__*/React.createElement("div", {
        onClick: this.onGoOneDrive,
        className: meClassname
      }, "My OneDrive"), this.props.groups.map(function (group) {
        var classname = 'section-item';

        if (_this2.state.activeSelection == group.graphId) {
          classname = classname + ' active';
        }

        return /*#__PURE__*/React.createElement("div", {
          key: 'group-' + group.graphId,
          className: classname,
          onClick: function onClick(e) {
            _this2.onGroupSelect(group);
          }
        }, group.title);
      })), /*#__PURE__*/React.createElement("div", {
        className: "ms-graph-file-picker"
      }, /*#__PURE__*/React.createElement(GraphFileBrowser, {
        getAuthenticationToken: this.getAuthenticationToken,
        itemMode: "multiple",
        endpoint: this.state.graphPickerUrl,
        onSuccess: this.onBrowserSuccess,
        onCancel: this.closeModal,
        key: "upload-wrapper-new_picker-element"
      }))) : null, this.isIframe() ? /*#__PURE__*/React.createElement(Expandable, {
        title: this.props.translate('attach-files')
      }, this.state.newPicker == null ? /*#__PURE__*/React.createElement(Spinner, {
        small: true,
        center: true
      }) : /*#__PURE__*/React.createElement("div", null, !this.state.newPicker ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(OneDrivePicker, {
        onChange: this.onOneDrivePickerChange
      }), /*#__PURE__*/React.createElement("div", {
        className: "upload-wrapper"
      }, this.state.pickedItems.length > 0 ? /*#__PURE__*/React.createElement("div", {
        className: "upload-container"
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('attached-files')), /*#__PURE__*/React.createElement("div", {
        className: "selected-files"
      }, this.filesList())) : null)) : null, this.state.newPicker ? /*#__PURE__*/React.createElement("div", {
        id: "upload",
        className: "upload-container"
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: function onClick(e) {
          e.preventDefault();

          _this2.openModal();
        }
      }, this.props.translate('open-sharepoint-onedrive')), /*#__PURE__*/React.createElement("div", {
        className: "selected-files"
      }, this.filesList())) : null)) : null, !this.isIframe() ? /*#__PURE__*/React.createElement(Expandable, {
        title: this.props.translate('attach-files')
      }, this.state.newPicker == null ? /*#__PURE__*/React.createElement(Spinner, {
        small: true,
        center: true
      }) : /*#__PURE__*/React.createElement("div", null, this.props.isLoading ? /*#__PURE__*/React.createElement("div", {
        className: "is_sending"
      }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
        className: "loading-spinner"
      }))) : null, this.state.newPicker ? /*#__PURE__*/React.createElement("div", {
        id: "upload",
        className: "upload-container"
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: function onClick(e) {
          e.preventDefault();

          _this2.openModal();
        }
      }, this.props.translate('open-sharepoint-onedrive')), /*#__PURE__*/React.createElement("div", {
        className: "selected-files"
      }, this.filesList())) : null, !this.state.newPicker ? /*#__PURE__*/React.createElement("div", {
        id: "upload",
        className: "upload-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "upload-buttons"
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: function onClick(e) {
          e.preventDefault();

          _this2.launchOneDrivePicker();
        }
      }, /*#__PURE__*/React.createElement(MS_OneDrive, null), " ", this.props.translate('open-sharepoint-onedrive'))), /*#__PURE__*/React.createElement("div", {
        className: "selected-files"
      }, this.filesList())) : null)) : null);
    }
  }]);

  return Upload;
}(Component);

function mapStateToProps(state) {
  return {
    tenant: state.user.tenant,
    translate: translate(state.Languages.translations),
    groups: state.sections.educationGroups
  };
}

export default connect(mapStateToProps, {
  addError: addError
})(Upload);